import Channel from '@/Enums/Channel.enum';
import MapScale from '@/Enums/Map/MapScale.enum';
import { isGamChannel } from '@/constants/forecaster';
import { STATE_MAP, ZIP_REGEX } from '@/constants/geography';

export const getTypeFromRadius = radius => {
  if (!radius) return null;
  return radius === 1 ? '1 mile' : `${radius} miles`;
};

export const getGeoFenceCoordinates = geoFence => {
  if (!geoFence) return null;
  const { latitude, longitude } = geoFence;
  return { latitude, longitude };
};

export const handlePasteStatesAndZipCodes = (value, selectedLocations) => {
  let remainingValue = value.replace(/,/g, ' '); // If there are commas, replace them with spaces
  const existing = new Set(selectedLocations.map(({ apiName }) => apiName));

  const pastedStates = new Set();
  const pastedZipCodes = new Set();

  const stateNames = Object.keys(STATE_MAP).sort((a, b) => b.length - a.length);

  while (remainingValue.length > 0) {
    let found = false;
    stateNames.forEach(state => {
      const stateRegex = new RegExp(`\\b${state}\\b`, 'i');
      if (remainingValue.match(stateRegex)) {
        pastedStates.add(STATE_MAP[state]);
        remainingValue = remainingValue.replace(stateRegex, '').trim();
        found = true;
      }
    });
    if (!found) {
      const delimiterIndex = remainingValue.search(/[,\s]/);
      const possibleValue = delimiterIndex === -1 ? remainingValue : remainingValue.slice(0, delimiterIndex);

      if (ZIP_REGEX.test(possibleValue)) {
        pastedZipCodes.add(possibleValue);
      } else {
        pastedStates.add(possibleValue);
      }

      if (delimiterIndex === -1) {
        break;
      } else {
        remainingValue = remainingValue.slice(delimiterIndex).trim();
      }
    }
  }

  return {
    states: [...pastedStates].filter(state => !existing.has(state)),
    zipCodes: [...pastedZipCodes].filter(code => !existing.has(code)),
  };
};

export const handlePasteZipCodes = (value, selectedLocations) => {
  const existingZipCodes = new Set(selectedLocations.map(({ apiName }) => apiName));
  const splitPastedZips = [...new Set(value.split(/[,\s]+/).filter(zip => zip && ZIP_REGEX.test(zip)))];

  return splitPastedZips.filter(zip => !existingZipCodes.has(zip));
};

export const getGeoSearchPlaceholder = currentChannel => {
  if (currentChannel === Channel.Dooh) {
    return 'Search by Zip Code. Multiple zip codes can be pasted, separated by a comma or a space.';
  }
  if (isGamChannel(currentChannel)) {
    return 'Search by States, Cities, Counties and Markets.';
  }
  return 'Search by States, Markets, Zip Codes, Counties and Congressional Districts. Multiple zip codes can be pasted, separated by a comma or a space.';
};

export const isZip = loc => loc.type === MapScale.Zip;

export const mergeZipsById = (a, b) => {
  const map = new Map();
  [...a, ...b].forEach(loc => map.set(loc.id, loc));
  return Array.from(map.values());
};
